import { render, staticRenderFns } from "./MyClips.vue?vue&type=template&id=37283a89&scoped=true&"
import script from "./MyClips.vue?vue&type=script&lang=js&"
export * from "./MyClips.vue?vue&type=script&lang=js&"
import style0 from "./MyClips.vue?vue&type=style&index=0&id=37283a89&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37283a89",
  null
  
)

export default component.exports